import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { channels } from "@/mocks/channels";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/lanmu", label: "栏目导航" },
  { to: "/changjianwenti", label: "常见问题" },
  { to: "/guanyu", label: "关于我们" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [channelOpen, setChannelOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setChannelOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="hidden border-b border-background-200/70 bg-background-100 md:block">
        <div className="mx-auto flex max-w-[1280px] items-center justify-between px-6 py-2 text-xs text-foreground-700">
          <span className="flex items-center gap-2">
            <i className="ri-flashlight-fill text-primary-500" />
            今日已更新 6 条内容 · 2026年9月14日
          </span>
          <span className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-verified-badge-line text-accent-600" />
              先求证，再表达
            </span>
            <a
              href="#footer-contact"
              className="flex items-center gap-1.5 text-foreground-700 transition-colors hover:text-primary-600"
            >
              <i className="ri-mail-line" />
              hello@51baoliao.com
            </a>
          </span>
        </div>
      </div>

      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-4 py-3 md:px-6 md:py-4">
        <Link to="/" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
            51
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              爆料网
            </span>
            <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">
              BAOLIAO PORTAL
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.slice(0, 2).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}

          <div
            className="relative"
            onMouseEnter={() => setChannelOpen(true)}
            onMouseLeave={() => setChannelOpen(false)}
          >
            <button
              type="button"
              onClick={() => setChannelOpen((v) => !v)}
              className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              内容板块
              <i className={`ri-arrow-down-s-line transition-transform ${channelOpen ? "rotate-180" : ""}`} />
            </button>
            {channelOpen && (
              <div className="absolute left-1/2 top-full w-[520px] -translate-x-1/2 pt-2">
                <div className="grid grid-cols-2 gap-1 rounded-lg border border-background-200 bg-background-50 p-3">
                  {channels.map((c) => (
                    <Link
                      key={c.slug}
                      to={`/pindao/${c.slug}`}
                      className="flex items-start gap-2.5 rounded-md px-3 py-2 transition-colors hover:bg-background-100"
                    >
                      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                        <i className={`${c.icon} text-base`} />
                      </span>
                      <span className="flex flex-col">
                        <span className="text-sm font-medium text-foreground-950">{c.name}</span>
                        <span className="text-xs text-foreground-500">{c.tagline}</span>
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {navItems.slice(2).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/lanmu"
            className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 md:flex md:items-center md:gap-1.5"
          >
            <i className="ri-compass-3-line" />
            站点导览
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMobileOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto max-w-[1280px] px-4 py-3">
            <div className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-2.5 text-sm font-medium ${
                      isActive ? "bg-primary-100 text-primary-800" : "text-foreground-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
            <p className="mt-3 mb-1 px-3 text-xs font-medium text-foreground-500">内容板块</p>
            <div className="grid grid-cols-2 gap-1">
              {channels.map((c) => (
                <Link
                  key={c.slug}
                  to={`/pindao/${c.slug}`}
                  className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-100"
                >
                  <i className={`${c.icon} text-primary-600`} />
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}